import React from "react";
import { CardsWrapper } from "../styles";
import { Box, Chip, colors, Divider, Pagination, Typography } from "@mui/material";
import {
	IComment,
	INVITATION_RESPONSE_MAP,
	INVITATION_RESPONSE_TYPE
} from "../../../../../store/services/invitations/dto/invitations.dto";
import { formatDate } from "../../../../../utils/formatDate";
import TableRowMenu from "../../../../../Components/MaterialTable/TableRowMenu";
import NoData from "../../../../../assets/imgs/search.svg";
import { StyleCircle } from "../../../../../Components/Inputs/Settings/styles";

const CardsList = ({
	data,
	page,
	perPage,
	totalItems,
	onPageChange,
	setDeleteResponse,
	setApproveResponse
}: {
	data: IComment[];
	page: number;
	perPage: number;
	totalItems: number;
	onPageChange: (page: number) => void;
	setDeleteResponse: React.Dispatch<React.SetStateAction<IComment | null>>;
	setApproveResponse: React.Dispatch<React.SetStateAction<IComment | null>>;
}) => {
	if ((data || []).length === 0) {
		return (
			<Box m={4} display={"flex"} justifyContent={"center"} alignItems={"center"} flexDirection={"column"}>
				<img src={NoData} alt="No comments found" width={250} />
				<Box mt={4}>
					<Typography variant={"h6"} fontWeight={"bold"}>
						No comments found
					</Typography>
				</Box>
			</Box>
		);
	}
	return (
		<CardsWrapper>
			{(data || []).map(item => {
				const emailUnverifiedCase = item.isApproved ? "Manually approved" : "Email unverified";
				return (
					<Box className={"card"} key={item._id}>
						<Box my={1} display={"flex"} justifyContent={"space-between"} px={1}>
							<Box display={"flex"} flexDirection={"column"} justifyContent={"center"} gap={1}>
								<Typography>{item.name}</Typography>
								<Box display={"flex"} alignItems={"center"} gap={1}>
									<StyleCircle
										$color={item.is_email_verified || item.isApproved ? colors.green[600] : colors.red[600]}
									/>
									<Typography fontSize={"14px"}>
										{item.is_email_verified || item.isApproved ? "Visible" : "Hidden"}
									</Typography>
								</Box>
							</Box>
							<Box display={"flex"} flexDirection={"column"} gap={1}>
								<Chip
									label={INVITATION_RESPONSE_MAP[item.response]}
									color={item.response === INVITATION_RESPONSE_TYPE.COMING ? "success" : "error"}
								/>
								<Typography fontSize={"12px"}>
									{item.is_email_verified ? "Email verified" : emailUnverifiedCase}
								</Typography>
							</Box>
						</Box>
						<Divider />
						<Box p={1} pb={0}>
							<Typography fontWeight={"bold"} style={{ overflowWrap: "break-word" }}>
								{item.comment}
							</Typography>
							<Box className={"card-footer"}>
								<Typography>{formatDate(item.createdAt)}</Typography>
								<TableRowMenu
									items={[
										{
											label: "Approve & Show",
											visible: !item.is_email_verified && !item.isApproved,
											onSelected: () => {
												setApproveResponse(item);
											}
										},
										{
											label: "Delete",
											visible: true,
											onSelected: () => {
												setDeleteResponse(item);
											}
										}
									]}
								/>
							</Box>
						</Box>
					</Box>
				);
			})}
			{!!(page && perPage && totalItems) && (
				<Box p={2} display={"flex"} justifyContent={"flex-end"}>
					<Pagination
						page={page}
						count={Math.ceil(totalItems / perPage)}
						shape="rounded"
						onChange={(event: unknown, newPage: number) => {
							onPageChange(newPage);
						}}
					/>
				</Box>
			)}
		</CardsWrapper>
	);
};

export default CardsList;
